export default __webpack_public_path__ + "static/media/profile.f2fa18a7.svg";